import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface IIPApiResponse {
    ip: string;
}

@Injectable({
    providedIn: 'root',
})
export class GetIPService {

    private httpClient: HttpClient;

    public constructor(private handler: HttpBackend) {
        // This will bypass Angular's HTTP interceptors.
        // Auth token, if exists, will not be passed with a request.
        this.httpClient = new HttpClient(handler);
    }

    public getUserIP(): Observable<IIPApiResponse> {
        return this.httpClient.get<IIPApiResponse>('https://api.ipify.org?format=json')
                   .pipe(
                       catchError(error => throwError(() => new Error('Error retrieving data!'))),
                   );
    }
}
